import React, { useCallback } from "react";
import { Pagination, PaginationProps } from "semantic-ui-react";
import { useObservationPagination } from "../../store/selectors/observationListSelectors";

export const WorkListPagination: React.FC = () => {

    const { pagination, gotoPage } = useObservationPagination();

    const onPageChangeWrapper = useCallback((_1, { activePage }: PaginationProps) => {
        const page = parseInt(activePage as string, 10);
        if (!Number.isNaN(page)) {
            gotoPage(page - 1);
            window.scrollTo(0, 0);
        }
    }, [gotoPage]);

    const totalPages = Math.ceil((pagination.totalItems || 0) / pagination.pageSize);

    // No need to render pagination if there's no pages
    if (totalPages <= 1) {
        return null;
    }

    return (
        <Pagination
            size="small"
            activePage={pagination.page + 1}
            onPageChange={onPageChangeWrapper}
            totalPages={totalPages}
            boundaryRange={1}
            siblingRange={1}
            firstItem={false}
            lastItem={false}
        />
    );
};
